import React, { useRef, useState } from "react";

// drag drop file component
const UploadZone = (props) => {
  // drag state
  const [dragActive, setDragActive] = useState(false);
  // ref
  const inputRef = useRef(null);

  const handleFile = (files, FileURL) => {
    props.SaveFile(files, FileURL);
  };

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  // handle drag events
  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const convertFileToBase64 = (file) => {
    const reader = new FileReader();
    reader.onload = function (event) {
      const base64String = event.target.result.split(",")[1];
      handleFile(file, base64String);
    };
    reader.readAsDataURL(file);
  };

  // triggers when file is dropped
  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();

    setDragActive(false);

    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      convertFileToBase64(e.dataTransfer.files[0]);
    }
  };

  // triggers when file is selected with click
  const handleChange = (e) => {
    e.preventDefault();
    if (e.target.files && e.target.files[0]) {
      convertFileToBase64(e.target.files[0]);
    }
  };

  // triggers the input when the button is clicked
  const onButtonClick = () => {
    inputRef.current.click();
  };

  return (
    <form
      id="form-file-upload"
      onDragEnter={(e) => handleDrag(e)}
      onSubmit={(e) => e.preventDefault()}
    >
      <input
        ref={inputRef}
        type="file"
        id="input-file-upload"
        accept=".zip, .pdf, .docx, .jpeg, .jpg, .png"
        multiple={false}
        onChange={(e) => handleChange(e)}
        onDragEnter={(e) => handleDrag(e)}
        onDragOver={(e) => handleDrag(e)}
        onSubmit={(e) => e.preventDefault()}
        onClick={() =>
          (document.getElementById("input-file-upload").value = null)
        }
      />
      <label
        id="label-file-upload"
        htmlFor="input-file-upload"
        className={dragActive ? "drag-active" : ""}
      >
        <div className="pre-upload">
          <i className="feather-file-text"></i>
          <div>
            {translateText("upload_zone_pt_1")}{" "}
            <button className="upload-button" onClick={(e) => onButtonClick(e)}>
              {translateText("upload_zone_pt_2")}
            </button>{" "}
            {"the PDF, DOCX, JPG, PNG, JPEG or ZIP " +
              translateText("files").toLowerCase()}
          </div>
        </div>
      </label>
      {dragActive && (
        <div
          id="drag-file-element"
          onDragEnter={(e) => handleDrag(e)}
          onDragLeave={(e) => handleDrag(e)}
          onDragOver={(e) => handleDrag(e)}
          onDrop={(e) => handleDrop(e)}
        ></div>
      )}
    </form>
  );
};

export default UploadZone;
